import { useQuery } from '@tanstack/react-query';
import { GetUserResponseDto, useApi } from '@issuemanager/api-client';
import { ExtendedAxiosError } from '@issuemanager/apps/client/hooks';

export function useMe() {
  const api = useApi();

  return useQuery<
    GetUserResponseDto,
    ExtendedAxiosError,
    GetUserResponseDto,
    string[]
  >({
    queryKey: ['users', 'me'],
    queryFn: () => api.usersApi.getMe().then((r) => r.data),
  });
}
